import React from "react";
import { MessageCircle, CheckCircle2 } from "lucide-react";
import { waLink } from "@/lib/api";

export default function FormSuccess({ message, waMessage, onReset, testId = "form-success" }) {
  return (
    <div className="bg-white border border-[#E2E8F0] rounded-2xl p-10 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid={testId}>
      <div className="w-16 h-16 mx-auto rounded-full bg-[#10B981]/10 flex items-center justify-center">
        <CheckCircle2 size={32} className="text-[#10B981]" strokeWidth={1.5} />
      </div>
      <h2 className="font-serif-display text-2xl text-[#0A2E4D] mt-6">Thank you!</h2>
      <p className="text-[#475569] mt-3 max-w-md mx-auto leading-relaxed">
        {message || "Thank you for contacting Makchester Tours & Travel. Our consultant will contact you shortly on WhatsApp."}
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <a href={waLink(waMessage || "Hello Makchester Tours & Travel, I just submitted a request.")} target="_blank" rel="noreferrer"
           className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe57] text-white px-6 py-3 rounded-full text-sm font-semibold" data-testid="success-whatsapp-btn">
          <MessageCircle size={16} /> WhatsApp a Travel Expert
        </a>
        {onReset && (
          <button onClick={onReset} className="text-sm text-[#0A2E4D] border-b-2 border-[#D4A62A] pb-0.5 hover:text-[#D4A62A]" data-testid="success-new-request">
            Submit another request
          </button>
        )}
      </div>
    </div>
  );
}
